import { Tag } from "@sprout/tag.tsx";
import "@/stylesheets/applications/stages.scss";
import { Body } from "@sprout/typography.tsx";
import ArrowDownIcon from "@sprout/icons/arrow_down.tsx";
import ArrowUpIcon from "@sprout/icons/arrow_up.tsx";
import { IconButton } from "@sprout/icon_button.tsx";
import { useState } from "react";
import { stageName } from "@utils/stage_name";
import useTranslation from "@hooks/use_translation";

interface Props {
  name: string;
  name_key?: string | null;
  description?: string | null;
  isCurrentStage: boolean;
}

export const StageCard = ({ name, name_key, description, isCurrentStage }: Props) => {
  const { t } = useTranslation("applications");
  const [showDescription, setShowDescription] = useState(isCurrentStage);
  const displayName = stageName({ name, name_key }, t);
  return (
    <>
      <div className="flex flex-col">
        <div className="flex">{isCurrentStage && <Tag label={"Current stage"}></Tag>}</div>
        <div className="flex justify-between">
          <Body>{displayName}</Body>
          {!!description &&
            (showDescription ? (
              <IconButton
                label={"collapse"}
                size="sm"
                icon={ArrowUpIcon}
                onClick={() => setShowDescription(false)}
              />
            ) : (
              <IconButton
                label={"expand"}
                size="sm"
                icon={ArrowDownIcon}
                onClick={() => setShowDescription(true)}
              />
            ))}
        </div>
      </div>
      {!!description && showDescription && (
        <div className="stage-description" dangerouslySetInnerHTML={{ __html: description }}></div>
      )}
    </>
  );
};
